import React from "react";

function Color_Schemes() {
  return (
    <div>
      <h1>Color_Schemes Component</h1>
      <p>This is the Color Schemes tutorial page content.</p>
    </div>
  );
}

export default Color_Schemes;
